<template>
    <footer class="site-footer" v-if="groupName == 'Deutsche Interim AG'">
        <div class="footer-container">
            <div class="row text-center">
                <div class="col-12">
                    <div class="align-center bottom-logo-container">
                        <a href="https://www.deutscheinterim.com/">
                            <img
                                src="/media/images/web_search/bottom-logo-di.png"
                                data-srcset="/themes/custom/deutsch/img/bottom-logo.png 1x"
                                data-src="/themes/custom/deutsch/img/bottom-logo.png"
                                width="218"
                                height="77"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="align-center footer-top-text-container">
                        <div class="footer-top-text-wrapper">
                            <div
                                id="block-deutsch-footertoptext"
                                class="block block-block-content block-block-content47830a61-f53e-44e6-94d4-8159815a4958"
                            >
                                <div class="content">
                                    <div
                                        class="clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__items text-center"
                                    >
                                        <div class="field__item">
                                            <p>
                                                {{
                                                    $trans(
                                                        "web_search.footer.di.description_line1",
                                                    )
                                                }}<br />
                                                {{
                                                    $trans(
                                                        "web_search.footer.di.description_line2",
                                                    )
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row footer-nav">
                <div class="col-sm-6 col-lg-3 col-xl-3">
                    <div class="row">
                        <div class="col-12">
                            <h3 class="privacy-title">
                                {{ $trans("web_search.footer.company") }}
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div
                                id="block-deutsch-footer"
                                class="block block-system block-system-menu-blockfooter col-12"
                            >
                                <ul
                                    id="block-deutsch-footer-1"
                                    class="clearfix nav navbar-nav privacy-links"
                                >
                                    <li class="nav-item">
                                        <a
                                            href="https://www.deutscheinterim.com/blog"
                                            class="nav-link nav-link-https--wwwdeutscheinterimcom-blog"
                                            >{{
                                                $trans(
                                                    "web_search.footer.di.blog",
                                                )
                                            }}</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="https://www.deutscheinterim.com/impressum"
                                            class="nav-link nav-link-https--wwwdeutscheinterimcom-impressum"
                                            >{{
                                                $trans(
                                                    "web_search.footer.imprint",
                                                )
                                            }}</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="https://www.deutscheinterim.com/datenschutz"
                                            title="Datenschutz"
                                            class="nav-link nav-link-https--wwwdeutscheinterimcom-datenschutz"
                                            >{{
                                                $trans(
                                                    "web_search.footer.privacy",
                                                )
                                            }}</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="https://info.deutscheinterim.com/kontakt-deutsche-interim-ag"
                                            class="nav-link nav-link-https--infodeutscheinterimcom-kontakt-deutsche-interim-ag"
                                            >{{
                                                $trans(
                                                    "web_search.footer.contact",
                                                )
                                            }}</a
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-3 col-xl-3">
                    <h3 class="contact-title">
                        {{ $trans("web_search.footer.follow_us") }}
                    </h3>
                    <div
                        class="bottom-social-wrapper d-flex align-items-center"
                    >
                        <a
                            href="https://www.linkedin.com/company/deutsche-interim-ag"
                            class="linkedin"
                            target="_blank"
                        >
                            <svg
                                width="80"
                                height="80.003"
                                viewBox="0 0 21.167 21.167"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15.33 10.91c-.149-1.193-.703-1.96-2.322-1.96-.958 0-1.597.341-1.853.852h-.021V8.95H9.366v6.348h1.853v-3.131c0-.831.17-1.619 1.172-1.619 1.022 0 1.108.937 1.108 1.683v3.088h1.896v-3.493a6.167 6.167 0 0 0-.065-.916zm2.245 6.466c-3.765 3.806-9.903 3.84-13.709.073C.061 13.684.028 7.546 3.794 3.74c3.765-3.805 9.903-3.838 13.709-.072a9.763 9.763 0 0 1 2.876 6.88 9.692 9.692 0 0 1-2.804 6.828M10.623.004a10.476 10.476 0 0 0-7.456 3.089l-.159.158c-4.073 4.162-4.002 10.838.159 14.911 4.161 4.074 10.837 4.003 14.91-.159a10.542 10.542 0 0 0 3.089-7.454c0-5.824-4.72-10.545-10.543-10.545m-4.75 15.315h2.214V8.971H5.872zm1.121-9.521H6.98a1.108 1.108 0 1 0 1.107 1.109v-.001a1.1 1.1 0 0 0-1.093-1.108"
                                    fill="#9c9e9f"
                                ></path>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6 col-xl-6">
                    <div class="row">
                        <div class="col-12">
                            <h3 class="regional-title" id="geo-footer">
                                {{ $trans("web_search.footer.regional") }}
                            </h3>
                            <div class="footer-bottom-text-container">
                                <nav
                                    role="navigation"
                                    id="block-geopagesfooter"
                                    class="block block-menu navigation menu--geo-pages-footer"
                                >
                                    <div class="row geo-pages-footer">
                                        <div
                                            class="col-12 col-sm-6 order-sm-1 col-lg-3 order-lg-1"
                                        >
                                            <ul
                                                id="block-geopagesfooter-1"
                                                class="clearfix nav navbar-nav"
                                            >
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-berlin"
                                                        class="nav-link"
                                                        >Berlin&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-einen-interim-manager-bielefeld"
                                                        class="nav-link"
                                                        >Bielefeld&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-einen-interim-manager-bonn"
                                                        class="nav-link"
                                                        >Bonn&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-darmstadt"
                                                        class="nav-link"
                                                        >Darmstadt&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-einen-interim-manager-dortmund"
                                                        class="nav-link"
                                                        >Dortmund&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            class="col-12 col-sm-6 order-sm-3 col-lg-3 order-lg-2"
                                        >
                                            <ul
                                                id="block-geopagesfooter-2"
                                                class="clearfix nav navbar-nav"
                                            >
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-einen-interim-manager-dresden"
                                                        class="nav-link"
                                                        >Dresden&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-duesseldorf"
                                                        class="nav-link"
                                                        >Düsseldorf&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-essen"
                                                        class="nav-link"
                                                        >Essen&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-frankfurt"
                                                        class="nav-link"
                                                        >Frankfurt&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-hamburg"
                                                        class="nav-link"
                                                        >Hamburg&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            class="col-12 col-sm-6 order-sm-2 col-lg-3 order-lg-3"
                                        >
                                            <ul
                                                id="block-geopagesfooter-3"
                                                class="clearfix nav navbar-nav"
                                            >
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-hannover"
                                                        class="nav-link"
                                                        >Hannover&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-kiel"
                                                        class="nav-link"
                                                        >Kiel&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-koeln"
                                                        class="nav-link"
                                                        >Köln&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-muenchen"
                                                        class="nav-link"
                                                        >München&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-muenster"
                                                        class="nav-link"
                                                        >Münster&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            class="col-12 col-sm-6 order-sm-4 col-lg-3 order-lg-4"
                                        >
                                            <ul
                                                id="block-geopagesfooter-4"
                                                class="clearfix nav navbar-nav"
                                            >
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-nuernberg"
                                                        class="nav-link"
                                                        >Nürnberg&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-stuttgart"
                                                        class="nav-link"
                                                        >Stuttgart&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>

    <footer
        class="site-footer swiss"
        v-else-if="groupName == 'Swiss Interim GmbH'"
    >
        <div class="footer-container">
            <div class="row text-center">
                <div class="col-12">
                    <div class="align-center bottom-logo-container">
                        <a href="https://www.swissinterim.com/">
                            <img
                                src="/media/images/web_search/logo_swiss_white_text.svg"
                                data-srcset="/themes/custom/deutsch/img/bottom-logo.png 1x"
                                data-src="/themes/custom/deutsch/img/bottom-logo.png"
                                width="218"
                                height="77"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="align-center footer-top-text-container">
                        <div class="footer-top-text-wrapper">
                            <div
                                id="block-deutsch-footertoptext"
                                class="block block-block-content block-block-content47830a61-f53e-44e6-94d4-8159815a4958"
                            >
                                <div class="content">
                                    <div class="text-center">
                                        <div class="field__item">
                                            <p>
                                                {{
                                                    $trans(
                                                        "web_search.footer.si.description_line1",
                                                    )
                                                }}<br />
                                                {{
                                                    $trans(
                                                        "web_search.footer.si.description_line2",
                                                    )
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row footer-nav">
                <div class="col-sm-6 col-lg-3 col-xl-3">
                    <div class="row">
                        <div class="col-12">
                            <h3 class="privacy-title">
                                {{ $trans("web_search.footer.company") }}
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div
                                id="block-deutsch-footer"
                                class="block block-system block-system-menu-blockfooter col-12"
                            >
                                <ul
                                    id="block-deutsch-footer-1"
                                    class="clearfix nav navbar-nav privacy-links"
                                >
                                    <li class="nav-item">
                                        <a
                                            href="https://www.swissinterim.com/blog"
                                            class="nav-link nav-link-https--wwwdeutscheinterimcom-blog"
                                            >{{
                                                $trans(
                                                    "web_search.footer.si.blog",
                                                )
                                            }}</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="https://www.swissinterim.com/impressum"
                                            class="nav-link nav-link-https--wwwdeutscheinterimcom-impressum"
                                            >{{
                                                $trans(
                                                    "web_search.footer.imprint",
                                                )
                                            }}</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="https://www.swissinterim.com/datenschutz"
                                            title="Datenschutz"
                                            class="nav-link nav-link-https--wwwdeutscheinterimcom-datenschutz"
                                            >{{
                                                $trans(
                                                    "web_search.footer.privacy",
                                                )
                                            }}</a
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-3 col-xl-3">
                    <h3 class="contact-title">
                        {{ $trans("web_search.footer.follow_us") }}
                    </h3>
                    <div
                        class="bottom-social-wrapper d-flex align-items-center"
                    >
                        <a
                            href="https://www.linkedin.com/company/swissinterim"
                            class="linkedin"
                            target="_blank"
                            ><svg
                                width="80"
                                height="80.003"
                                viewBox="0 0 21.167 21.167"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15.33 10.91c-.149-1.193-.703-1.96-2.322-1.96-.958 0-1.597.341-1.853.852h-.021V8.95H9.366v6.348h1.853v-3.131c0-.831.17-1.619 1.172-1.619 1.022 0 1.108.937 1.108 1.683v3.088h1.896v-3.493a6.167 6.167 0 0 0-.065-.916zm2.245 6.466c-3.765 3.806-9.903 3.84-13.709.073C.061 13.684.028 7.546 3.794 3.74c3.765-3.805 9.903-3.838 13.709-.072a9.763 9.763 0 0 1 2.876 6.88 9.692 9.692 0 0 1-2.804 6.828M10.623.004a10.476 10.476 0 0 0-7.456 3.089l-.159.158c-4.073 4.162-4.002 10.838.159 14.911 4.161 4.074 10.837 4.003 14.91-.159a10.542 10.542 0 0 0 3.089-7.454c0-5.824-4.72-10.545-10.543-10.545m-4.75 15.315h2.214V8.971H5.872zm1.121-9.521H6.98a1.108 1.108 0 1 0 1.107 1.109v-.001a1.1 1.1 0 0 0-1.093-1.108"
                                    fill="#9c9e9f"
                                ></path></svg
                        ></a>
                        <a
                            href="https://www.xing.com/pages/swiss-interim-gmbh"
                            class="linkedin"
                            target="_blank"
                            ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="80"
                                height="80"
                                viewBox="0 0 21.167 21.167"
                            >
                                <g style="fill: #9c9e9f; fill-opacity: 1">
                                    <path
                                        d="m0 0-10.3-18.12 6.667-11.7h6.97l-6.667 11.7L6.971 0Zm12.692-34.276c-10.713-10.828-28.176-10.921-39.004-.207C-37.141-23.77-37.233-6.307-26.52 4.521c10.714 10.829 28.177 10.921 39.005.208a27.778 27.778 0 0 0 8.182-19.577 27.577 27.577 0 0 0-7.975-19.428M-7.091 15.152a30.06 30.06 0 0 1-21.212-8.788 29.7 29.7 0 0 1-8.788-21.212c0-16.568 13.432-30 30-30 16.569 0 30 13.432 30 30 0 16.569-13.431 30-30 30m-6.181-20.546h-6.546l3.88-6.788-5.153-8.545h6.545l5.155 8.545z"
                                        style="
                                            fill: #9c9e9f;
                                            fill-opacity: 1;
                                            fill-rule: nonzero;
                                            stroke: none;
                                        "
                                        transform="matrix(.35278 0 0 -.35278 13.085 5.345)"
                                    ></path>
                                </g></svg
                        ></a>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6 col-xl-6 swiss-col-xl-6-section">
                    <div class="row">
                        <div class="col-12">
                            <h3 class="regional-title" id="geo-footer">
                                {{ $trans("web_search.footer.regional") }}
                            </h3>
                            <div class="footer-bottom-text-container">
                                <nav
                                    role="navigation"
                                    id="block-geopagesfooter"
                                    class="block block-menu navigation menu--geo-pages-footer"
                                >
                                    <div class="row geo-pages-footer">
                                        <div
                                            class="col-12 col-sm-6 order-sm-1 col-lg-3 order-lg-1"
                                        >
                                            <ul
                                                id="block-geopagesfooter-1"
                                                class="clearfix nav navbar-nav"
                                            >
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-berlin"
                                                        class="nav-link"
                                                        >Berlin&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-einen-interim-manager-bielefeld"
                                                        class="nav-link"
                                                        >Bielefeld&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-einen-interim-manager-bonn"
                                                        class="nav-link"
                                                        >Bonn&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-darmstadt"
                                                        class="nav-link"
                                                        >Darmstadt&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-einen-interim-manager-dortmund"
                                                        class="nav-link"
                                                        >Dortmund&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            class="col-12 col-sm-6 order-sm-3 col-lg-3 order-lg-2"
                                        >
                                            <ul
                                                id="block-geopagesfooter-2"
                                                class="clearfix nav navbar-nav"
                                            >
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-einen-interim-manager-dresden"
                                                        class="nav-link"
                                                        >Dresden&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-duesseldorf"
                                                        class="nav-link"
                                                        >Düsseldorf&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-essen"
                                                        class="nav-link"
                                                        >Essen&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-frankfurt"
                                                        class="nav-link"
                                                        >Frankfurt&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-hamburg"
                                                        class="nav-link"
                                                        >Hamburg&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            class="col-12 col-sm-6 order-sm-2 col-lg-3 order-lg-3"
                                        >
                                            <ul
                                                id="block-geopagesfooter-3"
                                                class="clearfix nav navbar-nav"
                                            >
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-hannover"
                                                        class="nav-link"
                                                        >Hannover&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-kiel"
                                                        class="nav-link"
                                                        >Kiel&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-koeln"
                                                        class="nav-link"
                                                        >Köln&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-muenchen"
                                                        class="nav-link"
                                                        >München&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-muenster"
                                                        class="nav-link"
                                                        >Münster&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            class="col-12 col-sm-6 order-sm-4 col-lg-3 order-lg-4"
                                        >
                                            <ul
                                                id="block-geopagesfooter-4"
                                                class="clearfix nav navbar-nav"
                                            >
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-nuernberg"
                                                        class="nav-link"
                                                        >Nürnberg&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        href="https://www.deutscheinterim.com/sie-suchen-interim-managerinnen-stuttgart"
                                                        class="nav-link"
                                                        >Stuttgart&nbsp;<i
                                                            >&gt;&gt;</i
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <footer class="site-footer matchmaker" v-else-if="groupName == 'Open HR'">
        <div class="footer-container">
            <div class="row text-center">
                <div class="col-12">
                    <div class="align-center bottom-logo-container">
                        <a href="https://www.opnhr.com/" target="_blank">
                            <img
                                src="/media/images/opnhr/opnhr_logo.svg"
                                width="218"
                                height="77"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="align-center footer-top-text-container">
                        <div class="footer-top-text-wrapper">
                            <div class="content">
                                <div class="text-center">
                                    <div class="field__item">
                                        <p>
                                            Open HR
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <footer class="site-footer matchmaker" v-else>
        <div class="footer-container">
            <div class="row text-center">
                <div class="col-12">
                    <div class="align-center bottom-logo-container">
                        <a href="https://www.matchmaker.de/">
                            <img
                                src="/media/images/web_search/logo_matchmaker.svg"
                                data-srcset="/themes/custom/deutsch/img/bottom-logo.png 1x"
                                data-src="/themes/custom/deutsch/img/bottom-logo.png"
                                width="218"
                                height="77"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="align-center footer-top-text-container">
                        <div class="footer-top-text-wrapper">
                            <div
                                id="block-deutsch-footertoptext"
                                class="block block-block-content block-block-content47830a61-f53e-44e6-94d4-8159815a4958"
                            >
                                <div class="content">
                                    <div class="text-center">
                                        <div class="field__item">
                                            <p>
                                                {{
                                                    $trans(
                                                        "web_search.footer.matchmaker.title",
                                                    )
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    props: {
        groupName: String,
    },
};
</script>

<style scoped>
.site-footer {
    background-color: #3c3c3c;
    padding-top: 40px;
    position: relative;
    color: #fff;
    font-size: 16px;
    line-height: 20px;
    width: 100%;
    padding-bottom: 100px;
}

.site-footer.swiss {
    background-color: #262f48;
    padding-bottom: 0;
}

.site-footer.matchmaker {
    background-color: #262f48;
    padding-bottom: 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
}

.text-center {
    text-align: center;
}

.footer-nav {
    display: flex;
    text-align: center;
    justify-content: center;
    position: relative;
}

.footer-nav::before {
    content: "";
    position: absolute;
    top: 0;
    left: 154px;
    right: 60px;
    height: 1px;
    background-color: #9c9e9f;
}

.col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
}

footer.site-footer h3 {
    position: relative;
    padding-bottom: 21px;
}

footer.site-footer .privacy-title::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 93px;
    right: 1px;
    height: 1px;
    background-color: #9c9e9f;
}

footer.site-footer .contact-title::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 20px;
    right: -122px;
    height: 1px;
    background-color: #9c9e9f;
}

footer.site-footer .regional-title::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: -2px;
    right: -4px;
    height: 1px;
    background-color: #9c9e9f;
}

footer.site-footer .contact-title {
    margin-right: 136px;
}

.nav-item > a {
    text-decoration: none;
    color: #fff;
}

.nav-item > a:hover {
    color: #aa916a;
    text-decoration: none;
}

.nav-link > i {
    color: #ff6b65;
    margin-left: 2px;
    position: relative;
    top: -1px;
}

.navbar-nav {
    text-align: left;
    list-style: none;
}

.privacy-links {
    margin-left: 18%;
}

.geo-pages-footer {
    display: flex;
    flex-wrap: wrap;
    margin-left: -40px;
    margin-right: -15px;
}

.nav-item {
    padding-bottom: 10px;
}

.bottom-social-wrapper {
    text-align: left;
}

.linkedin {
    margin-left: 19px;
}

.swiss-col-xl-6-section {
    visibility: hidden;
}

@media (max-width: 768px) {
    .site-footer {
        padding: 20px 10px;
        font-size: 14px;
    }

    .privacy-links {
        margin-left: unset;
    }

    footer.site-footer .privacy-title::after {
        left: 0px !important;
    }

    footer.site-footer .contact-title::after {
        left: 1px;
        right: -142px;
    }

    .site-footer .footer-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .footer-nav .row {
        flex-direction: column;
    }

    .footer-nav {
        display: block;
        text-align: unset;
        justify-content: unset;
        position: unset;
    }

    .footer-nav .col-sm-6,
    .footer-nav .col-lg-3,
    .footer-nav .col-xl-3,
    .footer-nav .col-md-12,
    .footer-nav .col-lg-6,
    .footer-nav .col-xl-6 {
        width: 100% !important;
        max-width: 100%;
        margin-bottom: 20px;
    }

    .footer-top-text-container,
    .footer-bottom-text-container,
    .bottom-logo-container {
        text-align: center;
    }

    .bottom-social-wrapper {
        justify-content: center;
        margin-top: 10px;
    }
}

@media (min-width: 768px) {
    .footer-nav .row {
        flex-direction: row;
    }

    .bottom-social-wrapper {
        justify-content: flex-start;
    }

    .footer-container {
        flex-direction: row;
        flex-wrap: wrap;
    }
}

@media (max-width: 768px) {
    .logo-link {
        margin-left: -136px;
        margin-top: 19px;
    }

    .searcher-wrapper {
        width: 95%;
    }

    .el-header {
        border-bottom: unset !important;
    }

    .privacy-title,
    .contact-title,
    .regional-title,
    .nav-item {
        padding-left: 10px;
    }
}
</style>
